import { Route, Routes } from "react-router-dom";

import { AccountDetailsLink } from "../../pages";

export const AccountDetailsLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<AccountDetailsLink />} />
    </Routes>
  );
};
